// const CORE_SERVICE_URL = "http://localhost:5001/core-svc/api/v1/";
// const USER_SERVICE_URL = "http://localhost:5000/user-svc/api/v1/user/";
// const BASE_URL = "http://localhost:5012/";
// const EQUITAS_VAN_URL = "http://localhost:5030/eqv-svc/api/v1";
// const EQUITAS_UPI_URL = "http://localhost:5033/eq-upi/api/v1";

// LOCAL
//const CORE_SERVICE_URL = "http://localhost:5001/core-svc/api/v1/";
//const USER_SERVICE_URL = "http://localhost:5009/user-svc/api/v1/user/";
//const BASE_URL = "http://localhost:5003/";

//master
 const CORE_SERVICE_URL = "https://collectbot.neokred.tech/core-svc/api/v1/";
 const USER_SERVICE_URL =
   "https://collectbot.neokred.tech/user-svc/api/v1/user/";
 const BASE_URL = "https://collectbot.neokred.tech/";
const EQUITAS_VAN_URL = "https://collectbot.neokred.tech/eqv-svc/api/v1";
const EQUITAS_UPI_URL = "https://collectbot.neokred.tech/eq-upi/api/v1";
const AXIS_SERVICE_URL = "https://collectbot.neokred.tech/ax-svc/api/v1"

// const AXIS_SERVICE_URL = "http://localhost:5020/ax-svc/api/v1"
export const API_ENDPOINT = {
  core_url: CORE_SERVICE_URL,
  axis_url: AXIS_SERVICE_URL,
  user_service_url: USER_SERVICE_URL,
  base_url: BASE_URL,
  equitas_van_url: EQUITAS_VAN_URL,
  equitas_upi_url: EQUITAS_UPI_URL
};  
